import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationES from '../locales/es/translation.json';
import translationEN from '../locales/en/translation.json';
import translationPT from '../locales/pt/translation.json';
import translationFR from '../locales/fr/translation.json';
import translationDE from '../locales/de/translation.json';

// Translation resources
const resources = {
    es: {
        translation: translationES,
    },
    en: {
        translation: translationEN,
    },
    pt: {
        translation: translationPT,
    },
    fr: {
        translation: translationFR,
    },
    de: {
        translation: translationDE,
    },
};

i18n
    // Detect user language
    .use(LanguageDetector)
    // Pass the i18n instance to react-i18next
    .use(initReactI18next)
    // Initialize i18next
    .init({
        resources,
        fallbackLng: 'es', // Default language
        debug: false, // Set to true for debugging

        // Language detection options
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },

        interpolation: {
            escapeValue: false, // React already escapes values
        },

        // Supported languages
        supportedLngs: ['es', 'en', 'pt', 'fr', 'de'],
    });

export default i18n;
